module.exports = __webpack_public_path__ + "static/ga-monopoly-logo-64eee8749c28101390640cce334dd2bd.png";